import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { QuoteProvider } from "@/context/QuoteContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import QuoteDrawer from "@/components/QuoteDrawer";
import SiteGate from "@/components/SiteGate";
import Home from "@/pages/Home";
import Timber from "@/pages/Timber";
import Doors from "@/pages/Doors";
import Furniture from "@/pages/Furniture";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Species from "@/pages/Species";
import MouldingDetail from "@/pages/MouldingDetail";
import KwilaMerbau from "@/pages/KwilaMerbau";
import Trade from "@/pages/Trade";
import About from "@/pages/About";
import Guides from "@/pages/Guides";
import GuideDetail from "@/pages/GuideDetail";
import Contact from "@/pages/Contact";
import RequestQuote from "@/pages/RequestQuote";
import Legal from "@/pages/Legal";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <QuoteProvider>
      <BrowserRouter>
        <ScrollToTop />
        <SiteGate>
          <div className="min-h-screen bg-cream text-ink">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/timber" element={<Timber />} />
              <Route path="/doors" element={<Doors />} />
              <Route path="/furniture" element={<Furniture />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/timber/species/:slug" element={<Species />} />
              <Route path="/timber/mouldings/:slug" element={<MouldingDetail />} />
              <Route path="/kwila-merbau" element={<KwilaMerbau />} />
              <Route path="/trade" element={<Trade />} />
              <Route path="/about" element={<About />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/guides/:slug" element={<GuideDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/request-quote" element={<RequestQuote />} />
              <Route path="/legal/:slug" element={<Legal />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <QuoteDrawer />
          </div>
        </SiteGate>
        <Toaster position="bottom-right" toastOptions={{ style: { background: "#1A110A", color: "#F7F5F0", border: "1px solid rgba(247,245,240,0.15)" } }} />
      </BrowserRouter>
    </QuoteProvider>
  );
}

export default App;
